module.exports = __webpack_public_path__ + "static/media/4.279e4f2d.png";